import { render, staticRenderFns } from "./EditFeedbackDialog.vue?vue&type=template&id=2d4ef438&scoped=true&"
import script from "./EditFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./EditFeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditFeedbackDialog.vue?vue&type=style&index=0&id=2d4ef438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ef438",
  null
  
)

export default component.exports